import { render } from "./MoviesArea.vue?vue&type=template&id=b525d150"
import script from "./MoviesArea.vue?vue&type=script&lang=js"
export * from "./MoviesArea.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__